var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      position: "relative"
    },
    style: {
      "--color": _vm.themeColor
    },
    on: {
      click: function ($event) {
        return _vm.$emit("itemClick");
      }
    }
  }, [_vm.pageType == "DETAILS" ? _c("top-title", {
    attrs: {
      themeColor: _vm.themeColor
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("理赔流程")))])]) : _vm._e(), _c("div", {
    staticClass: "imgBox"
  }, [_vm.styleObj.imgUrl ? _c("img", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      src: _vm.styleObj.imgUrl
    }
  }) : _vm._e()]), _c("div", [_vm._t("edit")], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };